// Only the loading skeleton reads this: a loaded row measures itself.
export const DATA_GRID_ROW_HEIGHT = 88;

export const DATA_GRID_TEXT_ROW_HEIGHT = 49;

export const BUTTON_HEIGHT_SMALL = 24;
export const BUTTON_HEIGHT_MEDIUM = 36;
export const BUTTON_HEIGHT_LARGE = 48;

// Lifts a cell's content to the top of a row taller than itself; cells center otherwise.
export const TOP_ALIGNED_CELL = 'cms-cell--top';

export const DISABLED_ROW = 'cms-row--disabled';

export const HOVER_ONLY_CELL = 'cms-cell--hoverOnly';

export const WRAPPED_CELL = 'cms-cell--wrapped';

export const ANCHOR_CELL = 'cms-cell--anchor';

// Marks a row the reader can open, so only a row with a link offers the affordance.
export const CLICKABLE_ROW = 'cms-row--clickable';

// The Data Grid exports its class names, but not the names of its CSS variables.
export const DATA_GRID_VARS = {
    // Ours: inherited, so a single cell can override its own padding.
    cellPadding: '--cms-grid-cell-padding',
    cellInset: '--cms-grid-cell-inset',

    rowBorderColor: '--DataGrid-rowBorderColor',
    containerBackground: '--DataGrid-containerBackground',
    overlayHeight: '--DataGrid-overlayHeight',
} as const;
